import { CalendarCacheStoreData } from 'owa-calendar-cache';
import { convertToCalendarCacheStoreData, getCalendarsService } from 'owa-calendarsapi-outlook';

export async function getCalendarServiceInCacheFormat(): Promise<CalendarCacheStoreData | null> {
    const response = await getCalendarsService();
    if (response === null || response.WasSuccessful === false) {
        return null;
    }
    const cacheData = convertToCalendarCacheStoreData(
        response.CalendarGroups,
        response.CalendarFolders
    );
    return cacheData;
}
